import { render, staticRenderFns } from "./tld.vue?vue&type=template&id=6b4acb31&scoped=true&"
import script from "./tld.vue?vue&type=script&lang=js&"
export * from "./tld.vue?vue&type=script&lang=js&"
import style0 from "./tld.vue?vue&type=style&index=0&id=6b4acb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4acb31",
  null
  
)

export default component.exports